import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxQrcodeStylingComponent } from 'ngx-qrcode-styling';
import { OpenSquashService } from '../../shared/services/open-squash-service';
import { MatchState } from '../../shared/model/match';
import { ControlMatch } from '../models/control-state';
import { environment } from '../../../../environments/environment';
import { parseCourtNumber } from '../../shared/util/court.util';

@Component({
  selector: 'app-assign-court-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgxQrcodeStylingComponent,
  ],
  templateUrl: './assign-court-dialog.html',
  styleUrl: './assign-court-dialog.scss',
})
export class AssignCourtDialogComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<AssignCourtDialogComponent>);
  private fb = inject(FormBuilder);
  private service = inject(OpenSquashService);

  match!: ControlMatch;
  totalCourts = 4;
  occupiedCourts: string[] = [];
  availableCourts: string[] = [];
  qrConfig: any;

  form: FormGroup = this.fb.group({
    court: ['', Validators.required],
  });

  ngOnInit(): void {
    this.match = this.data.match;
    this.totalCourts = this.data.totalCourts || 4;
    // Normalizar canchas ocupadas a su número (soporta datos legados "Cancha N")
    this.occupiedCourts = (this.data.occupiedCourts || [])
      .map((c: string) => parseCourtNumber(c))
      .filter((n: string) => !!n);

    // Generar lista de canchas disponibles (solo números)
    for (let i = 1; i <= this.totalCourts; i++) {
      const courtNumber = i.toString();
      if (!this.occupiedCourts.includes(courtNumber)) {
        this.availableCourts.push(courtNumber);
      }
    }

    // Pre-seleccionar la primera cancha libre
    if (this.availableCourts.length > 0) {
      this.form.patchValue({ court: this.availableCourts[0] });
    }

    // QR config
    this.qrConfig = {
      width: 200,
      height: 200,
      margin: 16,
      data: environment.urlApp + 'referee/' + this.match.code,
      image: 'images/no-avatar.png',
      qrOptions: { errorCorrectionLevel: 'M' },
      backgroundOptions: { color: '#faf9fd' },
      template: 'bitcoin',
    };
  }

  get player1Name(): string {
    return this.match.player1?.playerName || this.match.player1Id || '?';
  }

  get player2Name(): string {
    return this.match.player2?.playerName || this.match.player2Id || '?';
  }

  selectCourt(court: string): void {
    this.form.patchValue({ court });
  }

  submit(): void {
    if (this.form.valid) {
      const updated = { ...this.match };
      // Normalizar: guardar solo el número (sin prefijo "Cancha")
      updated.court = parseCourtNumber(this.form.value.court);
      updated.state = MatchState.EN_CANCHA;
      updated.playerIdWinner = null;
      // Limpiar campos de ControlMatch para no enviarlos a Firestore
      delete (updated as any).priority;
      delete (updated as any).manualOrder;
      delete (updated as any).categoryColor;
      delete (updated as any).progressPercent;
      delete (updated as any).estimatedMinutesLeft;
      delete (updated as any).playerAvailable;
      delete (updated as any).player1;
      delete (updated as any).player2;

      this.service.updateMatch(updated).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  exit(): void {
    this.dialogRef.close(null);
  }
}
